import { FileActionButton } from "../file-action/file-action-controls";
import { useState, useEffect } from 'react';
import editUserServices from '../../services/edit-users/edit-users.service';
import { CustomerReportResponse } from '../../models/all-user/edit-user-model';
import CustomerReportDataTable from './Customer-datatable';
import AppLoading from '../app-loading/app-loading';
import { exportCustomerReport } from './Customer-report-export';
import ReportPageHeader from '../shared/ReportPageHeader';

const CustomerReportMain = () => {
  const [reportData, setReportData] = useState<CustomerReportResponse>({
    columns: [],
    data: []
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        setIsLoading(true);
        const data = await editUserServices.getCustomerReport();
        setReportData(data);
      } catch (err) {
        setReportData({ columns: [], data: [] });
      } finally {
        setIsLoading(false);
      }
    };
    fetchReportData();
  }, []);

  const handleExport = () => {
    exportCustomerReport(reportData.columns, reportData.data);
  };

  if (isLoading) return <AppLoading />; 

  return (
  <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
    <div className="col-12">
      <ReportPageHeader
        icon="pi-users"
        title="Customer Report"
        subtitle="Review and export the latest customer report snapshot"
        actions={
          <FileActionButton action="export"
            className="text-black border-round"
            onClick={handleExport}
            icon="pi pi-file-export"
            text
            raised
            disabled={reportData.data.length === 0}
          >
            Export Report
          </FileActionButton>
        }
      />
    </div>

    <div className="report-container col-12">
      <CustomerReportDataTable 
        columns={reportData.columns} 
        data={reportData.data} 
        isLoading={isLoading}
      />
    </div>
  </div>
);

};

export default CustomerReportMain;
